<template>
  <a-modal
    :visible="dfVisible"
    :title="dfTitle"
    okText="Create"
    @cancel="() => { $emit('cancel') }"
    @ok="() => { $emit('create') }"
    width="50%"
    :destroyOnClose="true"
  >
    <a-form layout="vertical" :form="form">
      <a-form-item label="Domain">
        <a-input
          :size="size"
          v-decorator="[
              'domain',
              {
                rules: [{ required: true, message: 'Please input a valid domain name!', pattern: new RegExp(/(?=^.{4,253}$)(^((?!-)[a-zA-Z0-9-]{1,63}(?<!-)\.)+[a-zA-Z]{2,63}$)/) }]
              }
            ]"
        />
        <a-alert type="info" showIcon style="margin-top:5px;">
          <div
            slot="message"
          >Please provide a valid custom domain name. To complete this setup you will need access to your DNS Management system.</div>
        </a-alert>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import customDomainProxy from "@/helpers/CustomDomainProxy";

export default {
  data() {
    return {
      size: "large",
      proxy: customDomainProxy()
    };
  },
  props: ["dfVisible", "dfTitle"],
  beforeCreate() {
    this.form = this.$form.createForm(this);
  }
};
</script>

<style>
</style>
